"use client"

import { useRef, useState } from "react";
import { motion, useInView } from 'framer-motion';
import Image from "next/image";
import { ThankYou } from "../ThankYou";
import { CountrySelect } from "../CountrySelect";
import { useFormik } from "formik";
import * as yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js"


const validatePhoneNumber = (value) => {
  const phoneNumber = parsePhoneNumberFromString(value || "");
  return phoneNumber && phoneNumber.isValid();
};

const bgStyle = `
    @keyframes gradientFlow {
  0% {
    background-position: 100% 50%; /* Start from right */
  }
  100% {
    background-position: 0% 50%; /* Move to left */
  }
}
  `;

function PartnerPage({ blok }) {

  const becomeRef = useRef(null);
  const registerRef = useRef(null);


  const handleScrollToBecomeAPartner = () => {
    becomeRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };


  const handleScrollToRegisterAPartner = () => {
    registerRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);


  const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
  const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
  const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
  const isInView4 = useInView(ref4, { once: true, margin: "-100px" });
  const isInView5 = useInView(ref5, { once: true, margin: "-100px" });
  const isInView6 = useInView(ref6, { once: true, margin: "-100px" });
  const isInView7 = useInView(ref7, { once: true, margin: "-100px" });
  const isInView8 = useInView(ref8, { once: true, margin: "-100px" });

  const [open, setOpen] = useState(false);

  const validationSchema = yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    company: yup.string().required("Company Name is required"),
    email: yup.string().email("Invalid email format").required("Email is required"),
    phone: yup.string()
      .matches(/^[\d\s]+$/, 'Phone number must contain only digits')
      .min(10, 'Phone number must be at least 10 digits')
      .max(15, 'Phone number must be at most 15 digits') // optional upper limit
      .required("Phone is required"),
    noOfEmployees: yup.string().optional(),
    jobTitle: yup.string().required("Job Title is required"),
    country: yup.string().required("Country is required"),
    interstedInBecoming: yup.string().optional()
  });

  const { values: formData, handleChange, errors, resetForm, handleSubmit } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      company: "",
      email: "",
      phone: "",
      noOfEmployees: "",
      jobTitle: "",
      country: "",
      interstedInBecoming: []
    },
    validationSchema,
    onSubmit: async (values) => {
      setOpen(true)
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subject: "Form filled : Become a Partner", body: generateTable() }),
      });
      resetForm();
      const result = await response.json();
      if (result.success);
    }
  });


  function generateTable() {
    return `<table>
      <tr>
        <td>First Name</td>
        <td>${formData.firstName}</td>
      </tr>
      <tr>
        <td>Last Name</td>
        <td>${formData.lastName}</td>
      </tr>
      <tr>
        <td>Last Name</td>
        <td>${formData.company}</td>
      </tr>
      <tr>
        <td>Email</td>
        <td>${formData.email}</td>
      </tr>
       <tr>
        <td>Email</td>
        <td>${formData.phone}</td>
      </tr>
      <tr>
        <td>No of Employees</td>
        <td>${formData.noOfEmployees}</td>
      </tr>
      <tr>
        <td>Job Title</td>
        <td>${formData.jobTitle}</td>
      </tr>
      <tr>
        <td>Country</td>
        <td>${formData.country}</td>
      </tr>
      <tr>
        <td>Interested In Becoming</td>
        <td>${formData.interstedInBecoming}</td>
      </tr>
    </table>`
  }


  const generateTableRegisterADeal = (formData) => {
    return `<table>
      <tr>
        <td>First Name</td>
        <td>${formData.firstName}</td>
      </tr>
      <tr>
        <td>Last Name</td>
        <td>${formData.lastName}</td>
      </tr>
        <tr>
        <td>Email</td>
        <td>${formData.email}</td>
      </tr>
      <tr>
        <td>Phone</td>
        <td>${formData.phone}</td>
      </tr>
      <tr>
        <td>Company</td>
        <td>${formData.company}</td>
      </tr>
      <tr>
        <td>Prospect First Name</td>
        <td>${formData.prospectFirstName}</td>
      </tr>
      <tr>
        <td>Prospect Last Name</td>
        <td>${formData.prospectLastName}</td>
      </tr>
      <tr>
        <td>Prospect Email</td>
        <td>${formData.prospectEmail}</td>
      </tr>
      <tr>
        <td>Prospect Phone</td>
        <td>${formData.prospectPhone}</td>
      </tr>
      <tr>
        <td>Deal Amount</td>
        <td>${formData.dealAmount}</td>
      </tr>
      <tr>
        <td>Expected Close Date</td>
        <td>${formData.expectedCloseDate}</td>
      </tr>
      <tr>
        <td>Prospect Company Name</td>
        <td>${formData.prospectCompanyName}</td>
      </tr>
      <tr>
        <td>Interested In</td>
        <td>${formData.interestedIn.join(', ')}</td>
      </tr>
      </table>`
  }

  const registerADealValidationSchema = yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    company: yup.string().required("Company Name is required"),
    email: yup.string().email("Invalid email format").required("Email is required"),
    phone: yup.string()
     .matches(/^[\d\s]+$/, 'Phone number must contain only digits')
     .min(10, 'Phone number must be at least 10 digits')
     .max(15, 'Phone number must be at most 15 digits') // optional upper limit
     .required("Phone is required"),
    prospectFirstName: yup.string().required("Prospect First Name is required"),
    prospectLastName: yup.string().required("Prospect Last Name is required"),
    prospectEmail: yup.string().email("Invalid email format").required("Prospect Email is required"),
    prospectPhone: yup.string()
     .matches(/^[\d\s]+$/, 'Phone number must contain only digits')
     .min(10, 'Phone number must be at least 10 digits')
     .max(15, 'Phone number must be at most 15 digits') // optional upper limit
    .required("Prospect Phone is required"),
    dealAmount: yup.number().required("Deal Amount is required"),
    expectedCloseDate: yup.date().required("Expected Close Date is required"),
    prospectCompanyName: yup.string().required("Prospect Company Name is required"),
    interestedIn: yup.array().of(yup.string()).required("Interested In is required")
  });

  const { values: registerADeal, handleChange: handleRegisterADeal, errors: registerADealErrors, handleSubmit: handleRegisterADealSubmit, resetForm: handleRegisterADealReset } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      company: "",
      email: "",
      phone: "",
      jobTitle: "",
      country: "",
      prospectFirstName: "",
      prospectLastName: "",
      prospectEmail: "",
      prospectPhone: "",
      dealAmount: "",
      expectedCloseDate: "",
      prospectCompanyName: "",
      interestedIn: [],
    },
    validationSchema: registerADealValidationSchema,
    onSubmit: async (values) => {
      setOpen(true)
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subject: "Form filled : Register A Deal", body: generateTableRegisterADeal(values) }),
      });
      handleRegisterADealReset();
      const result = await response.json();
      if (result.success) downloadPDF();
    }
  })

  return (
    <div className=" m-auto">
      <div
        className="bg-asmPageTopBG"
        style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "bottom", // Center the background image
          backgroundRepeat: "repeat", // Prevent repeating the background
          // maxWidth: 1920,
          margin: "auto",
        }}
      >
        <div className=" m-auto">
          <div className="relative lg:min-h-[1000px] lg:flex flex-col items-center py-8  m-auto">
            {/* Header Section */}
            <div className="font-aileron pt-20 pb-5 lg:pt-32 lg:pb-32 text-center font-bold">
              <h1 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px] px-4 lg:px-0">
                {blok.titleText1}
              </h1>
              <div className="font-lato mt-4 text-[20px] w-[80%] lg:w-[100%] m-auto lg:text-[32px] font-normal ">
                {blok.subtitleText1}
              </div>
            </div>
            <div
              className="lg:w-full bg-asmPageMiddleBG p-2 lg:p-0"
              style={{
                backgroundSize: "cover", // Ensure the image covers the entire section
                backgroundPosition: "top", // Center the background image
                backgroundRepeat: "repeat", // Prevent repeating the background
                // maxWidth: 1920,
                margin: "auto",
              }}
            >
              {/* Main Content Section */}
              <div className="lg:flex justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[358px] rounded-[40px] lg:-mt-20 p-6 py-10 lg:p-0 m-10 lg:m-auto">
                {/* Left Column (Main Image) */}
                <div ref={ref1} className="w-full max-w-md">
                  <div className="lg:-mt-10 lg:w-[463px] lg:h-[455px] w-[200px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                    <motion.img
                      initial={{ opacity: 0, x: -100 }}
                      animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.2 }}
                      src={blok.image1.filename} />
                  </div>
                </div>

                <div className="lg:flex-1 flex flex-col justify-center">
                  {/* Description */}
                  <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 w-[90%] mb-6 m-auto text-center lg:text-start lg:m-0">
                    {blok.descriptionText1}
                  </p>
                  <div className="lg:flex lg:justify-start justify-center">
                    <button onClick={handleScrollToBecomeAPartner} className="bg-[#EF7B22] font-lato !text-white px-2 rounded hover:bg-[#d7691d] 
                    transition duration-150 w-full lg:w-[209px] lg:h-[45px] h-10 text-[18px]">
                      {blok.buttonText1}
                    </button>
                    <button onClick={handleScrollToRegisterAPartner} className="bg-white border border-[#EF7B22] text-[#EF7B22] px-4 py-2 rounded
                     hover:bg-[#EF7B22] hover:!text-white transition duration-150 w-full lg:w-[209px] lg:h-[45px] h-10 text-[18px] lg:ml-6 mt-4 lg:mt-0">
                      {blok.buttonText2}
                    </button>
                  </div>
                </div>
              </div>
              <div className="lg:flex justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[398px] rounded-[40px] lg:mt-16 p-6  py-10 lg:p-0 m-10 lg:m-auto">
                {/* Left Column (Main Image) */}
                <div className="lg:flex-1 mt-6 lg:ml-10">
                  <h5 className="font-aileron font-bold bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mb-2 text-center lg:text-start">
                    {blok.titleText2}
                  </h5>
                  {/* Description */}
                  <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 lg:w-[85%] mb-6 m-auto text-center lg:text-start lg:m-0">
                    {blok.descriptionText2}
                  </p>
                </div>
                <div ref={ref2} className="w-full max-w-md">
                  <div className="lg:-mt-10 lg:w-[463px] lg:h-[455px] w-[290px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0 lg:-ml-20">
                    <motion.img
                      initial={{ opacity: 0, x: 100 }}
                      animate={isInView2 ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.2 }}
                      src={blok.image2.filename} />
                  </div>
                </div>
              </div>
              <div className="lg:flex justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[444px] rounded-[40px] lg:mt-16 p-6  py-10 lg:p-0 m-10 lg:m-auto">
                {/* Left Column (Main Image) */}
                <div ref={ref3} className="w-full max-w-md">
                  <motion.div
                    initial={{ opacity: 0, x: -100 }}
                    animate={isInView3 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="lg:-mt-0 lg:w-[463px] lg:h-[455px] w-[290px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                    <img src={blok.image3.filename} />
                  </motion.div>
                </div>

                <div className="lg:flex-1 flex flex-col justify-center">
                  <h5 className="font-aileron font-bold bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mb-6 text-center lg:text-start">
                    {blok.titleText3}
                  </h5>
                  {/* Description */}
                  <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 lg:w-[90%] mb-6 m-auto text-center lg:text-start lg:m-0">
                    {blok.descriptionText3}
                  </p>
                </div>
              </div>
              <div className="lg:flex justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[480px] rounded-[40px] lg:mt-16 p-6  py-10 lg:p-0 m-10 lg:m-auto">
                {/* Left Column (Main Image) */}
                <div className="lg:flex-1 my-6 lg:px-10">
                  <h5 className="font-aileron font-bold bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mb-2 text-center lg:text-start">
                    {blok.titleText4}
                  </h5>
                  {/* Description */}
                  <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 lg:w-[85%] mb-6 m-auto text-center lg:text-start lg:m-0">
                    {blok.descriptionText4}
                  </p>
                </div>
                <div ref={ref4} className="w-full max-w-md">
                  <motion.div
                    initial={{ opacity: 0, x: 100 }}
                    animate={isInView4 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="lg:mt-6 lg:w-[463px] lg:h-[455px] w-[290px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0 lg:-ml-20">
                    <img src={blok.image4.filename} />
                  </motion.div>
                </div>

              </div>
              <div className="lg:flex justify-center lg:gap-[50px] lg:w-[1202px] mx-auto z-20 lg:mb-10 bg-white lg:h-[444px] rounded-[40px] lg:mt-16 p-6  py-10 lg:p-0 m-10 lg:m-auto">
                {/* Left Column (Main Image) */}
                <div ref={ref3} className="w-full max-w-md">
                  <motion.div
                    initial={{ opacity: 0, x: -100 }}
                    animate={isInView3 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="lg:-mt-0 lg:w-[463px] lg:h-[455px] w-[290px] lg:flex justify-center items-center m-auto mb-10 lg:mb-0">
                    <img src={blok?.TechinicalPartner?.[0]?.image?.filename} />
                  </motion.div>
                </div>

                <div className="lg:flex-1 flex flex-col justify-center">
                  <h5 className="font-aileron font-bold bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] lg:mb-6 text-center lg:text-start">
                    {blok?.TechinicalPartner?.[0]?.title}
                  </h5>
                  {/* Description */}
                  <p className="font-lato text-[16px] lg:text-[18px] lg:mb-6 lg:w-[90%] mb-6 m-auto text-center lg:text-start lg:m-0">
                    {blok?.TechinicalPartner?.[0]?.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="h-full lg:min-h-[1000px] -mt-8 "
        style={{
          background: `linear-gradient(90deg,
      #672C7B 0%,    /* Start with dark purple */
      #6D2F80 15%,   /* Intermediate soft purple */
      #493989 35%,   /* Shift to deep blue-purple */
      #4E3C92 50%,   /* Smooth blue transition */
      #493989 65%,   /* Keep consistency in blue-purple */
      #6D2F80 85%,   /* Return to soft purple */
      #672C7B 100%   /* End with dark purple */
    )`,
          backgroundSize: "400% 100%", // Makes the gradient wider than the container
          animation: "gradientFlow 20s linear infinite",
        }}
      >
        <style>{bgStyle}</style>
        <h1 ref={becomeRef} className="text-[24px] md:text-[48px] font-bold text-center !text-white pt-[61px] font-aileron">
          Become a Partner
        </h1>
        <h3 className="text-[16px] md:text-[28px] font-medium text-center !text-white  mb-4 lg:mb-20 pt-5 px-10 font-aileron">
          Accelerate business growth & extend brand visibility as a Securin Partner!
        </h3>
        <div className="flex justify-center items-center p-4 py-10 lg:pb-[107px]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-40 w-[1920px] max-w-7xl items-center">
            <div ref={ref5} className="text-center !text-white -mb-20 lg:mb-0">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={isInView5 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="w-[290px] h-[290px] md:w-[527px] md:h-[455px] flex items-center justify-center mx-auto md:mx-0 mb-4 md:mb-8">
                {/* Placeholder for Image */}
                <img src={"/images/partnerFormImage1.svg"} />
              </motion.div>
              <p className="mt-4 text-[18px] md:text-[24px] lg:text-left font-lato font-normal leading-7 !text-white">
                At Securin, we collaborate with our partners to expand awareness
                within the cybersecurity market and deliver unparalleled value.
                The Securin Partner Program helps create unique and mutually
                beneficial partnerships that offer growth opportunities,
                differentiated value propositions, executive commitment, and
                thought leadership around emerging technology innovations.
              </p>
            </div>
            <div>
              <form className="grid grid-cols-1 gap-4 font-lato">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block !text-white text-[18px]">
                      First Name <span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.firstName}
                      name="firstName"
                      placeholder="Enter Your First Name"
                      onChange={handleChange}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white"
                    />
                    {errors.firstName && <p className="py-2"><span className="text-red-200">{errors.firstName}</span></p>}
                  </div>
                  <div>
                    <label className="block !text-white text-[18px]">
                      Last Name <span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.lastName}
                      name="lastName"
                      onChange={handleChange}
                      placeholder="Enter Your Last Name"
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white"
                    />
                    {errors.lastName && <p className="py-2"><span className="text-red-200">{errors.lastName}</span></p>}
                  </div>
                </div>
                <div>
                  <label className="block !text-white text-[18px]">
                    Company Name <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Enter Your Company"
                    className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white"
                  />
                  {errors.company && <p className="py-2"><span className="text-red-200">{errors.company}</span></p>}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block !text-white text-[18px]">
                      Business Email <span className="text-red">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter Your Email"
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white"
                    />
                    {errors.email && <p className="py-2"><span className="text-red-200">{errors.email}</span></p>}
                  </div>
                  <div>
                    <label className="block !text-white text-[18px]">
                      Phone/Mobile <span className="text-red">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Eg. 213 456 7890"
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white"
                    />
                    {errors.phone && <p className="py-2"><span className="text-red-200">{errors.phone}</span></p>}
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block !text-white text-[18px]">
                      Number of Employees
                    </label>
                    <select value={formData.noOfEmployees} className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white" name="noOfEmployees" onChange={handleChange}>
                      <option>- Select -</option>
                      <option>1-10</option>
                      <option>11-50</option>
                      <option>51-200</option>
                      <option>201-500</option>
                      <option>500+</option>
                    </select>
                  </div>
                  <div>
                    <label className="block !text-white text-[18px]">
                      Job Title <span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      name="jobTitle"
                      value={formData.jobTitle}
                      onChange={handleChange}
                      placeholder="Enter Your Job Title"
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white"
                    />
                    {errors.jobTitle && <p className="py-2"><span className="text-red-200">{errors.jobTitle}</span></p>}
                  </div>
                </div>
                <div>
                  <label className="block !text-white text-[18px]">
                    Country <span className="text-red">*</span>
                  </label>
                  <CountrySelect value={formData.country} onChange={handleChange} />
                  {errors.country && <p className="py-2"><span className="text-red-200">{errors.country}</span></p>}
                </div>
                <div>
                  <div>
                    <label className="block !text-white text-[18px]">
                      Intersted In Becoming
                    </label>
                    <select value={formData.interstedInBecoming} className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white" name="interstedInBecoming" onChange={handleChange}>
                      <option>- Select -</option>
                      <option>Sales Partner</option>
                      <option>Service Partner</option>
                      <option>Integration Partner</option>
                      <option>Technical Alliance Partner</option>
                    </select>
                  </div>
                </div>
                <div className="text-sm text-white text-center flex items-center gap-1" style={{ color: "#fff" }}>
                  <input type="checkbox" id="termsAndConditions" name="termsAndConditions" required />
                  By submitting this form, you agree to our{" "}
                  <a href="/privacypolicy" className="text-white underline">
                    privacy policy
                  </a>
                </div>
                <div className="text-center lg:w-[532px]">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="bg-[#EF7B22] font-lato !text-white px-2 rounded hover:bg-[#d7691d] transition duration-150 w-full lg:w-[560px] lg:h-[69px] h-10 lg:text-[24px] text-[18px]"
                  >
                    Submit Form
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="bg-useCaseBottomBG py-10 lg:py-20"
        style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "center", // Center the background image
          backgroundRepeat: "repeat", // Prevent repeating the background
          // maxWidth: 1920,
          margin: "auto",
        }}
      >
        <div className="flex flex-col items-center text-center justify-center mt-10 lg:mt-0">
          <div className="mb-10">
            <div className="flex justify-center mb-10">
              <h5 className="font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] px-4 lg:text-[48px] font-bold">
                {blok.titleText5}
              </h5>
            </div>
            <div ref={ref6} className="grid lg:grid-cols-3 space-y-10 lg:space-y-0 w-[88%] m-auto lg:w-full mb-16">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={isInView6 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="relative w-full lg:w-[346px] rounded-lg p-[4px] bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                {/* Inner content div */}
                <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center px-2 py-4">
                  <img src={blok.cardImage1.filename} className="mb-0" />
                  <p className="font-lato text-[24px] text-[#49378F] font-bold mb-2">
                    {blok.cardTitle1}
                  </p>
                  <p className="text-[18px] font-lato w-[80%]">
                    {blok.cardDescription1}
                  </p>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={isInView6 ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="relative w-full lg:w-[346px] rounded-lg p-[4px] bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                {/* Inner content div */}
                <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center  px-2 py-4">
                  <img src={blok.cardImage2.filename} className=" mb-8" />
                  <p className="font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2 w-[80%]">
                    {blok.cardTitle2}
                  </p>
                  <p className="text-[18px] font-lato w-[90%]">
                    {blok.cardDescription2}
                  </p>
                </div>
              </motion.div>

              <motion.div

                initial={{ opacity: 0, x: 100 }}
                animate={isInView6 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }} className="relative w-full lg:w-[346px] rounded-lg p-[4px] bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                {/* Inner content div */}
                <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center px-2 py-4">
                  <img src={blok.cardImage3.filename} className="mb-8" />
                  <p className="font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2 w-[85%]">
                    {blok.cardTitle3}
                  </p>
                  <p className="text-[18px] font-lato w-[90%]">
                    {blok.cardDescription3}
                  </p>
                </div>
              </motion.div>
            </div>
            <motion.div
              ref={ref7}
              initial={{ opacity: 0, x: -100 }}
              animate={isInView7 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="grid lg:grid-cols-3 space-y-10 lg:space-y-0 w-[88%] m-auto lg:w-full">
              <div className="relative  w-full lg:w-[346px] rounded-lg p-[4px] bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50 mr-[50.28px]">
                {/* Inner content div */}
                <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center px-2 py-4">
                  <img src={blok.cardImage4.filename} className="mb-0" />
                  <p className="font-lato text-[24px] text-[#49378F] font-bold  mb-2">
                    {blok.cardTitle4}
                  </p>
                  <p className="text-[18px] font-lato w-[80%]">
                    {blok.cardDescription4}
                  </p>
                </div>
              </div>

              <motion.div
                ref={ref7}
                initial={{ opacity: 0, y: 50 }}
                animate={isInView7 ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="relative w-full lg:w-[346px] rounded-lg p-[4px] bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                {/* Inner content div */}
                <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center px-2 py-4">
                  <img src={blok.cardImage5.filename} className=" mb-8" />
                  <p className="font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2 w-[80%]">
                    {blok.cardTitle5}
                  </p>
                  <p className="text-[18px] font-lato w-[90%]">
                    {blok.cardDescription5}
                  </p>
                </div>
              </motion.div>

              <motion.div
                ref={ref7}
                initial={{ opacity: 0, x: 100 }}
                animate={isInView7 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="relative w-full lg:w-[346px] rounded-lg p-[4px] bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                {/* Inner content div */}
                <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center px-2 py-4">
                  <img src={blok.cardImage6.filename} className="mb-8" />
                  <p className="font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2 w-[85%]">
                    {blok.cardTitle6}
                  </p>
                  <p className="text-[18px] font-lato w-[90%]">
                    {blok.cardDescription6}
                  </p>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
        {/* <Footer blok={blok} /> */}
      </div>
      {/* <div className="w-full flex justify-center">
        <div className="max-w-7xl flex gap-10 self-center py-10 lg:py-20 px-10 flex-wrap">
          <div className="lg:flex-1 w-full lg:w-auto"><img src={blok?.TechinicalPartner?.[0]?.image?.filename} /></div>
          <div className="flex-1">
            <h1 className="font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:px-4 text-center lg:text-left lg:text-[48px] font-bold">
              {blok?.TechinicalPartner?.[0]?.title}
            </h1>
            <p className="mx-5 text-center lg:text-left">{blok?.TechinicalPartner?.[0]?.description}</p>
          </div>
        </div>
      </div> */}
      <div ref={registerRef} className="h-full lg:min-h-[1100px] -mt-10 bg-formBg lg:mt-0">
        <h1 className="text-[28px] md:text-[48px] font-bold text-center bg-custom-radial bg-clip-text text-transparent mb-4 lg:mb-20 pt-[61px] font-aileron">
          Register A Deal
        </h1>
        <div className="flex justify-center items-center lg:px-4 px-4 lg:pt-4 pt-4 lg:pb-4 pb-10">
          <div ref={ref8} className="grid grid-cols-1 md:grid-cols-2 gap-40 w-[1920px] max-w-7xl items-start">
            <div className="text-center -mb-20 lg:mb-0">
              <p className="font-bold font-lato lg:text-[32px] text-[24px] text-center lg:text-left lg:w-[70%]">
                Thanks For Recommending Us To Your Client
              </p>
              <div className="w-[290px] h-[290px] md:w-[527px] md:h-[455px] flex items-center justify-center mx-auto md:mx-0 mb-4 md:mb-8">
                {/* Placeholder for Image */}
                <motion.img
                  initial={{ opacity: 0, x: -100 }}
                  animate={isInView8 ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  src={"/images/partnerFormImage2.svg"} />
              </div>

              <p className="mt-4 text-[18px] md:text-[24px] lg:text-left font-lato font-normal leading-8">
                Registering a deal with us is easy. Simply complete the form and
                we will reach out to verify your registration within 24 hours.{" "}
                If you have any questions, please contact us at{" "}
                <span className="underline underline-offset-1">
                  partners@securin.io
                </span>
                .
              </p>
            </div>
            <div>
              <form className="grid grid-cols-1 gap-4 font-lato" onSubmit={handleRegisterADealSubmit}>
                <h1 className="font-lato lg:text-[32px] text-[24px] text-center lg:text-left font-medium">Partner Information</h1>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[18px]">First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      value={registerADeal.firstName}
                      placeholder="Enter Your First Name"
                      onChange={handleRegisterADeal}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                    />
                    {registerADealErrors.firstName &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.firstName}</span></p>}
                  </div>
                  <div>
                    <label className="block text-[18px]">Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      value={registerADeal.lastName}
                      onChange={handleRegisterADeal}
                      placeholder="Enter Your Last Name"
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                    />
                    {registerADealErrors.lastName &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.lastName}</span></p>}
                  </div>
                </div>
                <div>
                  <label className="block text-[18px]">
                    Company Name</label>
                  <input
                    type="text"
                    placeholder="Enter Your Company"
                    name="company"
                    value={registerADeal.company}
                    onChange={handleRegisterADeal}
                    className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                  />
                  {registerADealErrors.company &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.company}</span></p>}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[18px]">Business Email</label>
                    <input
                      type="email"
                      name="email"
                      value={registerADeal.email}
                      onChange={handleRegisterADeal}
                      placeholder="Enter Your Email"
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                    />
                    {registerADealErrors.email &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.email}</span></p>}
                  </div>
                  <div>
                    <label className="block text-[18px]">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={registerADeal.phone}
                      onChange={handleRegisterADeal}
                      placeholder="Enter Your Number"
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                    />
                    {registerADealErrors.phone &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.phone}</span></p>}
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-4">
                  <h1 className="font-lato lg:text-[32px] text-[24px] text-center lg:text-left font-medium mt-4">Prospects Information</h1>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[18px]">
                      Prospect Fist Name
                    </label>
                    <input
                      type="text"
                      name="prospectFirstName"
                      value={registerADeal.prospectFirstName}
                      onChange={handleRegisterADeal}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                      placeholder="Enter Prospect's First Name" />
                      {registerADealErrors.prospectFirstName &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.prospectFirstName}</span></p>}
                  </div>
                  <div>
                    <label className="block text-[18px]">
                      Prospect Last Name
                    </label>
                    <input
                      type="text"
                      name="prospectLastName"
                      value={registerADeal.prospectLastName}
                      onChange={handleRegisterADeal}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                      placeholder="Enter Prospect's First Name" />
                      {registerADealErrors.prospectLastName &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.prospectLastName}</span></p>}
                  </div>
                  <div>
                    <label className="block text-[18px]">
                      Prospect Email
                    </label>
                    <input
                      type="email"
                      name="prospectEmail"
                      value={registerADeal.prospectEmail}
                      onChange={handleRegisterADeal}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                      placeholder="Enter Prospect's Email" />
                      {registerADealErrors.prospectEmail &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.prospectEmail}</span></p>}
                  </div>
                  <div>
                    <label className="block text-[18px]">
                      Prospect Phone Number
                    </label>
                    <input
                      type="tel"
                      name="prospectPhone"
                      value={registerADeal.prospectPhone}
                      onChange={handleRegisterADeal}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                      placeholder="Enter Prospect's Phone Number" />
                      {registerADealErrors.prospectPhone &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.prospectPhone}</span></p>}
                  </div>
                  <div>
                    <lable className="block text-[18px]">Deal Amount</lable>
                    <input
                      type="number"
                      name="dealAmount"
                      value={registerADeal.dealAmount}
                      onChange={handleRegisterADeal}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white" />
                      {registerADealErrors.dealAmount &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.dealAmount}</span></p>}
                  </div>
                  <div>
                    <lable className="block text-[18px]">Expected Close Date</lable>
                    <input
                      type="date"
                      name="expectedCloseDate"
                      onChange={handleRegisterADeal}
                      value={registerADeal.expectedCloseDate}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14 bg-white" />
                      {registerADealErrors.expectedCloseDate &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.expectedCloseDate}</span></p>}
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-4">
                  <div className="w-full">
                    <label className="block text-[18px]">Prospect Company Name</label>
                    <input
                      type="text"
                      name="prospectCompanyName"
                      onChange={handleRegisterADeal}
                      value={registerADeal.prospectCompanyName}
                      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
                      placeholder="Enter Prospect's Company Name" />
                      {registerADealErrors.prospectCompanyName &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.prospectCompanyName}</span></p>}
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                  <div>
                    <label className="block text-[18px]">Interested In</label>
                    {["Attack Surface Management", "Vulnerability Intelligence", "Vulnerability Management", "Penetration Testing", "Becoming a Partner"].map((interest) => (
                      <label key={interest} className="block">
                        <input
                          type="checkbox"
                          name="interestedIn"
                          value={interest}
                          checked={registerADeal.interestedIn.includes(interest)}
                          onChange={handleRegisterADeal}
                          className="mr-2 text-[#443b81] focus:border-1 focus:outline-none focus:border-[#5A27E7] accent-[#5A27E7]"
                        />
                        {interest}
                      </label>
                    ))}
                    {registerADealErrors.interestedIn &&  <p className="py-2"><span className="text-red-600">{registerADealErrors.interestedIn}</span></p>}
                  </div>
                </div>
                <div className="text-center lg:w-[532px] mb-10">
                  <button
                    type="submit"
                    className="bg-[#EF7B22] font-lato !text-white px-2 rounded hover:bg-[#d7691d] transition duration-150 w-full lg:w-[560px] lg:h-[69px] h-10 lg:text-[24px] text-[18px]"
                  >
                    Submit Form
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {open && <ThankYou onClose={setOpen} />
      }
      {/* <Footer blok={blok} /> */}
    </div>
  );
}

export default PartnerPage;
